import api from "./axios";

function asPositiveInt(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.trunc(n);
}

export async function listUserOpsTripRequests(userId) {
  const idNum = asPositiveInt(userId);
  if (!idNum) throw new Error("Missing or invalid userId");

  const { data } = await api.get(`/api/ops-bookings/user/${encodeURIComponent(String(idNum))}`);
  return Array.isArray(data?.items) ? data.items : [];
}

export async function listActiveUserOpsTripRequests(userId) {
  const idNum = asPositiveInt(userId);
  if (!idNum) throw new Error("Missing or invalid userId");

  const { data } = await api.get(`/api/ops-bookings/user/${encodeURIComponent(String(idNum))}`, {
    params: { scope: "active" },
  });
  return Array.isArray(data?.items) ? data.items : [];
}

export async function verifyOpsBookingPayment(body) {
  const { data } = await api.post("/api/ops-bookings/payment/verify", body);
  if (data && typeof data.success === "boolean") return data;
  return { success: false, message: "Invalid ops verify response" };
}

export async function reconcileOpsBookingPayment(body) {
  const { data } = await api.post("/api/ops-bookings/payment/reconcile", body);
  if (data && typeof data.success === "boolean") return data;
  return { success: false, message: "Invalid ops reconcile response" };
}

export async function placeWaivedOpsBooking(body = {}) {
  const { data } = await api.post("/api/ops-bookings/place-waived", body);
  if (data && typeof data.success === "boolean") return data;
  return { success: false, message: "Invalid waived booking response" };
}
